import type { SharedData, UserRole } from "@src/context/ApplicationContext";
import { v4 as uuidv4 } from "uuid";

type SetDataFn = (key: keyof SharedData, value: any) => void;

interface EnsureUserUuidOptions {
  currentUserUuid?: string | null;
  setData: SetDataFn;
  forceRegenerate?: boolean;
  generateUuid?: () => string;
}

interface EnsureUserUuidResult {
  userUuid: string;
  created: boolean;
}

export const ensureUserUuid = ({
  currentUserUuid,
  setData,
  forceRegenerate = false,
  generateUuid,
}: EnsureUserUuidOptions): EnsureUserUuidResult => {
  if (!forceRegenerate && currentUserUuid) {
    return {
      userUuid: currentUserUuid,
      created: false,
    };
  }

  const userUuid = generateUuid?.() ?? uuidv4();
  setData("userUuid", userUuid);

  return {
    userUuid,
    created: true,
  };
};

export const resolveUserRoleForFlow = (
  isInSalesforce: boolean,
  isReferrerFlow?: boolean,
): UserRole => {
  if (isInSalesforce && !isReferrerFlow) {
    return "patient navigator";
  }

  return isReferrerFlow ? "referrer" : "patient";
};
